export default "__VITE_ASSET__GR3EXJAX__"